import { render, staticRenderFns } from "./InformalPatchRequestForm.vue?vue&type=template&id=c536511a&scoped=true"
import script from "./InformalPatchRequestForm.vue?vue&type=script&lang=js"
export * from "./InformalPatchRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c536511a",
  null
  
)

export default component.exports